import React, { useEffect, useState } from "react";
import CustomInput from "../../CustomInput/CustomInput";
import Board from "../BoardItem/BoardItem";
import { getTaskById, putRoadmap } from "../../../services/tasks/tasks";
import { useParams } from "react-router-dom";
import "./Dash.css";

function Dashboard() {
  const [boards, setBoards] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [members, setMembers] = useState([]);
  let { id } = useParams();

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    getTaskById(id)
      .then((res) => {
        console.log("res by id : ", res);
        setBoards(res.boards.Boards);
        setMembers(res.boards);
        setDataLoaded(true);
        console.log("res : ", res);
      })
      .catch((e) => {
        console.error("err : ", e);
      });
    // const boardsFromLocal = await fetchBoardList();
  }

  useEffect(() => {
    // updateLocalStorageBoards(boards);
    // let payload = { ik: "1666765731594.52", title: "test", cards: boards };
    dataLoaded && updateRoadMap();
  }, [boards, id]);

  const [targetCard, setTargetCard] = useState({
    boardId: 0,
    cardId: 0,
  });

  const updateRoadMap = () => {
    // let arr = [...boards];
    // let boardsArr = arr.map((board) => {
    //   // delete board.id;
    //   board.cards.map((card) => {
    //     // delete card.id;
    //     // card.tasks.map(task => delete task.id);
    //     return card;
    //   });
    //   return board;
    // });
    // console.log("boardsArr ", boardsArr);
    console.log("boards : test ", boards);
    let payload = { Boards: boards };
    putRoadmap(id, payload);
  };

  const addboardHandler = (name) => {
    const tempBoardsList = [...boards];
    tempBoardsList.push({
      id: parseInt(Date.now() + Math.random() * 2),
      // id: ,
      // id: boards.length + 1,
      title: name,
      cards: [],
    });
    setBoards(tempBoardsList);
    console.log("1 : ", boards);
  };

  const removeBoard = (boardId) => {
    const boardIndex = boards.findIndex((item) => item._id === boardId);
    if (boardIndex < 0) return;
    const tempBoardsList = [...boards];
    tempBoardsList.splice(boardIndex, 1);
    setBoards(tempBoardsList);
    console.log("2 : ", boards);
  };

  const addCardHandler = (boardId, title, myBoardId) => {
    const boardIndex = boards.findIndex((item) => item._id === boardId);
    console.log("boardindex is less then", boardIndex);
    console.log("board id :", boardId);
    if (boardIndex < 0) return;
    const tempBoardsList = [...boards];
    console.log("tempBoardsList", tempBoardsList);
    console.log("boardIndex", boardIndex);
    let card = {
      // id: boardId,
      id: parseInt(Date.now() + Math.random() * 2),
      // id: tempBoardsList[boardIndex].cards,
      title,
      labels: [],
      date: "",
      tasks: [],
      desc: "",
    };
    console.log("Card ......", card);
    tempBoardsList[boardIndex].cards.push(card);
    setBoards(tempBoardsList);
    console.log("tempBoardsList addCardHandler ", tempBoardsList);
    console.log("boards addCardHandler ", boards);
    // let boardsArr = boards.map(board => {
    //   board.cards.map(card => delete card.id)
    //   return board;
    // });
    // console.log("boardsArr ", boardsArr);
    // let payload = { boards: boards };
    // putRoadmap(id, payload);
  };

  const removeCard = (boardId, cardId) => {
    const boardIndex = boards.findIndex((item) => item._id === boardId);
    if (boardIndex < 0) return;

    const tempBoardsList = [...boards];
    const cards = tempBoardsList[boardIndex].cards;

    const cardIndex = cards.findIndex((item) => item._id === cardId);
    if (cardIndex < 0) return;

    cards.splice(cardIndex, 1);
    console.log("remove card tempBoardsList function : ", tempBoardsList);
    console.log("remove card func  ( cards )  : ", cards);
    console.log("remove card func  cardId  : ", cardId);
    setBoards(tempBoardsList);
  };

  const updateCard = (boardId, cardId, card) => {
    console.log("board id in update card :", boardId, cardId, card)
    const boardIndex = boards.findIndex((item) => item._id === boardId);
    console.log("board index : ", boardIndex);
    if (boardIndex < 0) return;

    const tempBoardsList = [...boards];
    const cards = tempBoardsList[boardIndex].cards;

    const cardIndex = cards.findIndex((item) => item._id === cardId);
    if (cardIndex < 0) return;

    tempBoardsList[boardIndex].cards[cardIndex] = card;

    setBoards(tempBoardsList);

    console.log("3 : ", boards);
  };

  const onDragEnd = (boardId, cardId) => {
    const sourceBoardIndex = boards.findIndex((item) => item._id === boardId);
    if (sourceBoardIndex < 0) return;

    const sourceCardIndex = boards[sourceBoardIndex]?.cards?.findIndex(
      (item) => item._id === cardId
    );
    if (sourceCardIndex < 0) return;

    const targetBoardIndex = boards.findIndex(
      (item) => item._id === targetCard.boardId
    );
    if (targetBoardIndex < 0) return;

    const targetCardIndex = boards[targetBoardIndex]?.cards?.findIndex(
      (item) => item._id === targetCard.cardId
    );
    if (targetCardIndex < 0) return;

    const tempBoardsList = [...boards];
    const sourceCard = tempBoardsList[sourceBoardIndex].cards[sourceCardIndex];
    tempBoardsList[sourceBoardIndex].cards.splice(sourceCardIndex, 1);
    tempBoardsList[targetBoardIndex].cards.splice(
      targetCardIndex,
      0,
      sourceCard
    );
    setBoards(tempBoardsList);
    setTargetCard({
      boardId: 0,
      cardId: 0,
    });
    console.log("4 : ", boards);
  };

  const onDragEnter = (boardId, cardId) => {
    if (targetCard.cardId === cardId) return;
    setTargetCard({
      boardId: boardId,
      cardId: cardId,
    });
    console.log("5 : ", boards);
  };

  // useEffect(() => {
  //  dispatch(setBoardsData(boards))
  // }, [boards])

  // update tittle in boards
  const handleUpdateTile = (selectBoard, editValue) => {
    let newBoards = boards.map((elm, index) => {
      if (elm._id == selectBoard._id) {
        return { ...elm, title: editValue };
      }
      return elm
    })
    setBoards(newBoards);
  }

  return (
    <div className="app">
      <div className="app-nav"></div>
      <div className="app-boards-container mt-2">
        <div className="app-boards">
          {boards.map((item, index) => (
            <Board
              key={index}
              myBoardId={index + 1}
              board={item}
              addCard={addCardHandler}
              removeBoard={() => removeBoard(item._id)}
              removeCard={removeCard}
              onDragEnd={onDragEnd}
              onDragEnter={onDragEnter}
              updateCard={updateCard}
              members={members}
              handleUpdateTile={handleUpdateTile}
            />
          ))}
          <div className="app-boards-last">
            
            <CustomInput
              displayClass="app-boards-add-board"
              editClass="app-boards-add-board-edit"
              placeholder="Enter Board Name"
              text="Add Board"
              buttonText="Add Board"
              onSubmit={addboardHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
